const LEVERAGES = [1, 100, 400];

export default LEVERAGES;